export default __webpack_public_path__ + "static/media/Wolf's Hood of a Hundred Eyes.41eb9057.jpg";